import { colors, FormControl, FormHelperText, styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller } from 'react-hook-form';

const CustomBorderDatePicker = styled(DatePicker)`
    & .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
            border-color: #3A3A3A;
        }
    }
`;

const AuthDatePicker = (props) => {
    const {
        hookFormControl,
        varName,
        placeholder = "",
        disabled = false,
        readOnly = false,
        errorMessage,
        minDate = null,
        maxDate = null,
        size = "small",
    } = props;

    return (
        <>
            <FormControl error={errorMessage !== null} size={size} fullWidth>
                {/* <InputLabel htmlFor={varName}>{label}</InputLabel> */}
                <Controller
                    name={varName}
                    control={hookFormControl}
                    render={({ field }) => (
                        <CustomBorderDatePicker
                            disabled={disabled}
                            readOnly={readOnly}
                            format='dd/MM/yyyy'
                            {...field}
                            minDate={minDate}
                            maxDate={maxDate}
                            slotProps={{ textField: { placeholder, InputProps: { className: "rounded-full" }, size, inputProps: { className: "rounded-full font-['Poppins-Regular'] text-[15px] text-center" } } }}
                        />
                    )}
                />
                {errorMessage && (
                    <FormHelperText className="ml-0 font-['Poppins-Regular'] text-[11px]" id="component-error-text">
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </>
    );
};

export default AuthDatePicker;
